var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4749 2.52513C12.8417 3.89197 12.8417 6.10804 11.4749 7.47488C10.108 8.84172 7.89197 8.84172 6.52513 7.47488C5.15829 6.10804 5.15829 3.89197 6.52513 2.52513C7.89197 1.15829 10.108 1.15829 11.4749 2.52513",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.4998V17.4998C1 18.0518 1.448 18.4998 2 18.4998H16C16.552 18.4998 17 18.0518 17 17.4998V16.4998C17 13.4738 13.048 11.5078 9 11.5078C4.952 11.5078 1 13.4738 1 16.4998Z",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.7c3fcbf6b26e13df509c5d7697d39766.svg";
export { ForwardRef as ReactComponent };